import type { Tenant } from '../../lib/database.types';

/**
 * Section « Paramètres » de l'admin (parité legacy Settings tab) :
 * abonnement Lil & Co, domaine du site, impression.
 * Les paiements Stripe ont leur onglet dédié (« Paiements Stripe ») — plus de doublon ici.
 */
const BILLING_LABEL: Record<string, { label: string; tone: string }> = {
  none: { label: 'Aucun', tone: 'bg-slate-100 text-slate-600' },
  free: { label: 'Offert', tone: 'bg-emerald-50 text-emerald-700' },
  trial: { label: 'Essai', tone: 'bg-amber-50 text-amber-700' },
  active: { label: 'Actif', tone: 'bg-emerald-50 text-emerald-700' },
  suspended: { label: 'Suspendu', tone: 'bg-red-50 text-red-700' },
};

export default function SettingsPanel({ tenant }: { tenant: Tenant }) {
  const status = tenant.billing_status ?? 'none';
  const billing = BILLING_LABEL[status] ?? BILLING_LABEL.none;
  const shopUrl = `/r/${tenant.slug}`;

  return (
    <div className="flex flex-col gap-5">
      {/* Abonnement */}
      <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white">
        <div className="bg-gradient-to-r from-brand-primary to-brand-dark p-5 text-white" style={{ background: 'linear-gradient(135deg, var(--brand-primary), var(--brand-dark))' }}>
          <h3 className="text-lg font-bold">Mon abonnement Lil &amp; Co</h3>
          <p className="text-sm opacity-90">Click &amp; Collect — 99 €/mois</p>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-3 p-5">
          <div>
            <div className="flex items-center gap-2">
              <span className="font-bold">Statut</span>
              <span className={'rounded-md px-2 py-0.5 text-xs font-semibold ' + billing.tone}>{billing.label}</span>
            </div>
            {status === 'trial' && tenant.trial_ends_at && (
              <p className="mt-1 text-sm text-slate-500">Fin d'essai : {new Date(tenant.trial_ends_at).toLocaleDateString('fr-FR')}</p>
            )}
            <p className="mt-1 text-sm text-slate-500">La facturation est gérée par Lil &amp; Co (Odoo).</p>
          </div>
        </div>
      </div>

      {/* Domaine */}
      <div className="rounded-2xl border border-slate-200 bg-white p-5">
        <h3 className="mb-3 text-base font-bold">🌐 Domaine du site</h3>
        <ul className="flex flex-col gap-2 text-sm">
          <li className="flex items-center justify-between rounded-lg bg-slate-50 px-3 py-2">
            <span className="font-mono">lilco-app.pages.dev{shopUrl}</span>
            <span className="rounded-md bg-emerald-50 px-2 py-0.5 text-xs font-semibold text-emerald-700">Par défaut</span>
          </li>
          <li className="flex items-center justify-between rounded-lg bg-slate-50 px-3 py-2">
            <span className="text-slate-500">Domaine personnalisé (ex. votre-resto.fr)</span>
            <span className="rounded-md bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-500">À configurer</span>
          </li>
        </ul>
        <p className="mt-2 text-xs text-slate-400">Pour brancher un domaine personnalisé, contactez Lil &amp; Co.</p>
      </div>

      {/* Impression / tablette */}
      <div className="rounded-2xl border border-slate-200 bg-white p-5">
        <h3 className="mb-2 text-base font-bold">🖨️ Impression des tickets</h3>
        <p className="text-sm text-slate-600">
          L'impression des tickets cuisine se fait depuis le <strong>Mode tablette</strong> : bouton « Imprimer » sur
          chaque commande, ou « Impression auto » pour imprimer à chaque nouvelle commande. Branchez une imprimante
          ticket à l'appareil qui affiche la tablette.
        </p>
        <a href={`/r/${tenant.slug}/tablet`} className="mt-3 inline-block rounded-lg bg-emerald-600 px-3 py-2 text-sm font-semibold text-white hover:bg-emerald-700">
          📱 Ouvrir le mode tablette
        </a>
      </div>
    </div>
  );
}
